const redirectLinkWhatsapp = (medical_record) => {
  const phoneNumber = process.env.REACT_APP_NUMBER_SCHEDULE_WHATSAPP;
  let msg = process.env.REACT_APP_MESSAGE_SCHEDULE_WHATSAPP;
  msg = msg.replace(
    '|*medical_record*',
    `|*${medical_record ?? 'Não Informado'}*`
  );
  const messageText = encodeURIComponent(msg);
  const link = `https://wa.me/${phoneNumber}?text=${messageText}&locale=pt_br`;

  return link;
};

export default redirectLinkWhatsapp;
